
		<div class="btn-group btn-group-sm" role="group" aria-label="Источник" *ngIf="showMe">
			<button
				*ngFor="let source of ['0', '1', '2']"
				type="button"
				[class]="filter.filterParams.source == source ? 'btn btn-info' : 'btn btn-outline-info'"
				(click)="setSource(source)"
			>
				{{ 'adminstat.common.clusters.' + source | translate }}
			</button>
		</div>
	